// @ts-nocheck
import create from 'zustand';
import { immer } from 'zustand/middleware/immer';
import _ from 'lodash';
import { axios } from "./axios";
import { toast } from "sonner";
import { showError, showSuccess } from "../actions/globalActions";

const baseUrl = `${process.env.API_URL}/api/v1`;

const createAuthHeader = (token) => {
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

const usePlayerStore = create(immer((set) => ({
  players: [],

  // Methods to manipulate the state
  setPlayers: (players) => {
    set((state) => {
      state.players = players;
    });
  },

  // Asynchronous actions
  getPlayerById: async (id) => {
    try {
      const { data } = await axios.get(`${baseUrl}/players/${id}`);
      set((state) => {
        state.players.push(data.result);
      });
    } catch (error) {
      console.error("Error in getPlayerById:", error);
    }
  },

  getPlayersByTeamId: async (id) => {
    try {
      const { data } = await axios.get(`${baseUrl}/players/team/${id}?include=team`);
      set((state) => {
        state.players = data.result;
      });
    } catch (error) {
      console.error("Error in getPlayersByTeamId:", error);
    }
  },

  getPlayersByGameId: async (id) => {
    try {
      const { data } = await axios.get(`${baseUrl}/players/game/${id}?include=team`);
      set((state) => {
        state.players = data.result;
      });
    } catch (error) {
      console.error("Error in getPlayersByGameId:", error);
    }
  },

  getPlayersByRegistrationId: async (id) => {
    try {
      const { data } = await axios.get(`${baseUrl}/players/registration/${id}?include=team`);
      set((state) => {
        state.players = data.result;
      });
    } catch (error) {
      console.error("Error in getPlayersByRegistrationId:", error);
    }
  },

  getPlayersByLeagueName: async (name) => {
    try {
      const { data } = await axios.get(`${baseUrl}/players/organizationName/${name}`);
      set((state) => {
        state.players = data.result;
      });
    } catch (error) {
      console.error("Error in getPlayersByLeagueName:", error);
    }
  },

  searchPlayer: async (name, leagueName) => {
    try {
      const { data } = await axios.get(`${baseUrl}/players/search/?q=${name}&leagueName=${leagueName}&include=team,organization`);
      set((state) => {
        state.players = data.result.map(player => ({ ...player, searchName: name }));
      });
    } catch (error) {
      console.error("Error in searchPlayer:", error);
    }
  },

  getPlayersWithFilters: async (params = {}) => {
    try {
      let query = helpers.jsonToQueryString(params);
      const { data } = await axios.get(`${baseUrl}/players/?${query}&include=team`);
      set((state) => {
        state.players = data.result;
      });
    } catch (error) {
      console.error("Error in getPlayersWithFilters:", error);
    }
  },

  updatePlayer: (getToken) => {
    return async (player, cb = () => {}) => {
      try {
        const token = await getToken();
        const { error, result, status } = (await axios.put(`${baseUrl}/players/d/${player._id}`, player, createAuthHeader(token))).data;
        error ? toast.error(error) : toast.success(`Successfully Updated!`);
        set((state) => {
          const index = state.players.findIndex(p => p._id === result._id);
          if (index !== -1) {
            state.players[index] = result;
          }
        });
        cb && cb(result);
      } catch (error) {
        showError("Error", "Update Error");
        console.error("Error in updatePlayer:", error);
      }
    }
  },

  // Throws on failure so form callers (AddForm) show the real error and stay
  // open — it used to swallow errors (e.g. the org-membership 403), push an
  // undefined row into `players`, AND let AddForm toast "Successfully
  // created!" over a create that never happened.
  addPlayer: (getToken) => {
    return async (player) => {
      const token = await getToken();
      const { error, result } = (await axios.post(`${baseUrl}/players/d`, player, createAuthHeader(token))).data;
      if (error) throw new Error(error);
      set((state) => {
        state.players.push(result);
      });
      return result;
    }
  },

  invitePlayer: (getToken) => {
    return async (player) => {
      try {
        const token = await getToken();
        const { error, result } = (await axios.post(`${baseUrl}/players/d/invite`, player, createAuthHeader(token))).data;
        if (error) { toast.error(error); return { error }; }
        toast.success('Invitation sent!');
        set((state) => {
          state.players.push(result);
        });
        return { result };
      } catch (error: any) {
        const msg = error?.response?.data?.error || 'Error sending invitation';
        toast.error(msg);
        console.error("Error in invitePlayer:", error);
        return { error: msg };
      }
    }
  },

  deletePlayer: (getToken) => {
    return async (playerId, deleteRegistration) => {
      try {
        const token = await getToken();
        console.log('deletePlayer::', playerId, deleteRegistration);

        const { data } = await axios.delete(`${baseUrl}/players/${playerId}?registrationTeam=${deleteRegistration ? deleteRegistration: ''}`, createAuthHeader(token));
        console.log('deletePlayer2::', data);
        if (!data.error) {
          set((state) => {
            state.players = state.players.filter(p => p._id !== playerId);
          });
        }
        // Return the response body so DataTable's DeleteDialog can toast on it
        // (success -> "Successfully deleted!", failure -> data.error).
        return data;
      } catch (error: any) {
        console.error("Error in deletePlayer:", error);
        return { error: error?.response?.data?.error || 'Error removing player' };
      }
    }
  },

})));

export default usePlayerStore;
